import {Box, Tab, Tabs} from "@mui/material";
import {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {useRecoilState} from "recoil";
import SectionHeader from "../../../../util/component/SectionHeader";
import {Route, Routes, useLocation, useNavigate} from "react-router-dom";
import {STATE_ACTIVE_TAB} from "../../component/Constants";
import BlackListPage from "./BlackListPage";
import NotAuthorizedDialog from "../../../authentication/component/NotAuthorizedDialog";
import * as React from "react";
import {useHasScope} from "../../../../config/globalConfig";
import {SCOPE_BLACK_LIST} from "../../component/utils/AuthConstants";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>
                    {children}
                </Box>
            )}
        </div>
    );
}

const PageBlackListArchived = (props: any) => {
    const {t} = useTranslation(['finessecurity'], {keyPrefix: 'blackList'});

    const [activeTab, setActiveTab] = useRecoilState(STATE_ACTIVE_TAB);
    const navigate = useNavigate();
    const location = useLocation();
    const hasScope = useHasScope;

    function a11yProps(index: number) {
        return {
            id: `simple-tab-${index}`, 'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const changeTabAndPath = (newValue: any) => {
        setActiveTab(newValue);
        navigate(newValue ? '/finessecurity/watchlist/archived' : '/finessecurity/watchlist');
    }

    useEffect(() => {
        if (location.pathname === "/finessecurity/watchlist") {
            setActiveTab(0);
        } else if (location.pathname === "/finessecurity/watchlist/archived") {
            setActiveTab(1);
        }
    }, [])

    return (
        hasScope(SCOPE_BLACK_LIST) ?

            <Box>
                <SectionHeader title={t('listHeader.title')}
                               subtitle={t('listHeader.subTitle')}/>
                <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                    <Tabs value={activeTab} onChange={(_event, newValue: number) => changeTabAndPath(newValue)}>
                        <Tab label={t('blacklisted')} {...a11yProps(0)} />
                        <Tab label={t('archived')} {...a11yProps(1)} />
                    </Tabs>
                </Box>
                <TabPanel value={activeTab} index={0}>
                    <Routes>
                        <Route path="/" element={
                            <BlackListPage/>
                        }>
                        </Route>
                    </Routes>
                </TabPanel>
                <TabPanel value={activeTab} index={1}>
                    <Routes>
                        <Route path="/archived" element={
                            <BlackListPage archived={true}/>
                        }>
                        </Route>
                    </Routes>
                </TabPanel>
            </Box>

        : <NotAuthorizedDialog/>

    );
}

export default PageBlackListArchived;